export const version = '2.49.10';
//# sourceMappingURL=version.js.map